/**
 * This mixin adds functionality to a list of objects to sum up the totals for
 * properties that have number values. The original purpose of this mixin is
 * to display the totals for various columns in a table of data
 */
import filterable from './filterable.mixin.js';

export default {
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    displayTotals: {
      type: Boolean,
    },
    totalCounts: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mixins: [filterable],
  computed: {
    itemTotals() {
      if (this.filterServerSide) {
        return this.totalCounts;
      }
      const items = this.filteredItems;
      return items.reduce((acc, next) => {
        // iterate properties
        for (let k in next) {
          // skip properties with non-number values
          const isNumber = !isNaN(+next[k]);
          if (isNumber) {
            // set default value if the accumulator doesn't have it yet
            acc[k] = acc[k] || 0;
            acc[k] += +next[k];
          }
        }
        return acc;
      }, {});
    },
  },
};
